import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

import ExposedFilterMenu from './ExposedFilterMenu';
import GenderFilterButtons from './GenderFilterButtons';
import LocationFilterButton from './LocationFilterButton';
import HealthTestFilterButton from './HealthTestFilterButton';
import GoHomeDateFilterButton from './GoHomeDateFilterButton';
import AgeFilterButton from './AgeFilterButton';

const IS_LT_MD = isLessThanBreakpoint('md');
const isAdultsDogsSearchResultsEnabled = isFeatureEnabled(
  FEATURES.REL_ADULT_DOGS_SEARCH_RESULTS
);

export default function ExposedFilters({ resultsType, totalItemCount }) {
  return (
    <div
      className={classnames('SearchResultsExposedFilters flex gap-8 ', {
        'overflow-auto no-scrollbars': IS_LT_MD
      })}
    >
      <LocationFilterButton
        resultsType={resultsType}
        totalItemCount={totalItemCount}
      />
      {resultsType === RESULTS_TYPES.PUPPIES && (
        <>
          <GenderFilterButtons />
          {isAdultsDogsSearchResultsEnabled ? (
            <AgeFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
          ) : (
            <GoHomeDateFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
          )}
        </>
      )}
      {resultsType === RESULTS_TYPES.BREEDERS && (
        <HealthTestFilterButton
          resultsType={resultsType}
          totalItemCount={totalItemCount}
        />
      )}
      <ExposedFilterMenu
        resultsType={resultsType}
        totalItemCount={totalItemCount}
      />
    </div>
  );
}
ExposedFilters.propTypes = {
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};
